import { SearchInput } from "PFApp/components/search_input";
import { Button } from "PFComponents/button/button";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "./booking_config.scss";

type BookingConfigSearchProps = {
  term: string;
  onTermChange: (value: string) => void;
};

export const BookingConfigSearch = ({ term, onTermChange }: BookingConfigSearchProps) => {
  const { t } = useTranslation();

  return (
    <div className={css.searchContainer}>
      <SearchInput term={term} onTermChange={onTermChange} rootClassName={css.rootInput} />
      {term && (
        <Button kind="text" onClick={() => onTermChange("")} icon="filter-clean" text={t("clearSearch")} />
      )}
    </div>
  );
};
